export const getDayPhase = () => {
  if (typeof window !== "undefined" && window.__ADE_PHASE__) return window.__ADE_PHASE__;
  const now = new Date();
  const h = now.getHours() + now.getMinutes() / 60;
  if (h >= 5.5 && h < 8) return "dawn";
  if (h >= 8 && h < 17) return "day";
  if (h >= 17 && h < 20.5) return "sunset";
  return "night";
};

export const PHASE_LABELS = { dawn: "Alba", day: "Giorno", sunset: "Tramonto", night: "Notte" };

const TINTS = {
  dawn: "linear-gradient(180deg, rgba(255,170,110,0.28) 0%, rgba(255,120,150,0.14) 45%, rgba(0,0,0,0) 75%)",
  day: "none",
  sunset: "linear-gradient(180deg, rgba(255,110,50,0.32) 0%, rgba(255,60,110,0.16) 50%, rgba(40,20,70,0.12) 100%)",
  night: "linear-gradient(180deg, rgba(8,16,44,0.22) 0%, rgba(8,16,44,0.16) 55%, rgba(6,12,38,0.22) 100%)",
};

/* Subtle realistic weather overlay for the Leaflet world map (pointer-events: none) */
export const OceanWeather = () => {
  const phase = getDayPhase();
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ zIndex: 450 }} data-testid="ocean-weather" data-phase={phase}>
      <style>{`
        @keyframes ow-glint { 0%,100% { opacity: 0.12; } 50% { opacity: 0.3; } }
      `}</style>
      {/* sun glint on the water */}
      {phase !== "night" && (
        <div style={{
          position: "absolute", top: "15%", right: "12%", width: 220, height: 220, borderRadius: "50%",
          background: `radial-gradient(circle, ${phase === "day" ? "rgba(255,255,230,0.5)" : "rgba(255,180,90,0.55)"} 0%, transparent 65%)`,
          mixBlendMode: "screen", animation: "ow-glint 7s ease-in-out infinite",
        }} />
      )}
      {/* moon at night */}
      {phase === "night" && (
        <div style={{
          position: "absolute", top: "10%", right: "14%", width: 46, height: 46, borderRadius: "50%",
          background: "radial-gradient(circle at 35% 35%, #f4f6fb 0%, #cfd8ea 55%, #9aa8c7 100%)",
          boxShadow: "0 0 40px 14px rgba(210,225,255,0.28)",
        }} />
      )}
      {/* time-of-day color grading */}
      <div style={{ position: "absolute", inset: 0, background: TINTS[phase], mixBlendMode: phase === "night" ? "multiply" : "soft-light" }} />
    </div>
  );
};

export default OceanWeather;
